import { FlexGap, StackVertical, useTranslation } from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef } from 'react';
import { AccountHeader } from '../Components/AccountHeader';
import GetInTouch from '../../_Global/Components/GetInTouch';
import { GuidedTour } from '../../_Global/Components/GuidedTour';
import ActivityFeed from '../ActivityFeed/ActivityFeed';
import AccountTipsBlock from '../AccountTips/AccountTipsBlock';
import { AccountAllowance } from '../AccountAllowance/AccountAllowance';
import { AccountIssues } from '../AccountIssues/AccountIssues';
import { AccountStats } from '../AccountStats/AccountStats';
import { useSite } from '../../_Global/Providers/SiteInterfaceProvider';

function Overview() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();

	const overviewContainer = useRef<any>(null);

	useEffect(() => {
		updatePageMeta({
			title: t('overviewPage.title'),
		});
	}, [currentLocale]);

	return (
		<div className='content-main content-area-narrow' ref={overviewContainer}>
			<div className='container-narrow'>
				<StackVertical>
					<AccountHeader />

					<AccountIssues />

					<AccountAllowance />

					<div className='row mb-xl'>
						<div className='col-xs-12'>
							<AccountStats />
						</div>
					</div>

					<div className='row mb-xl'>
						<div className='col-xs-12 col-lg-8 mb-lg'>
							<ActivityFeed />
						</div>
						<div className='col-xs-12 col-lg-4'>
							<h6 className='sub-heading mb-xs'>{t('overviewPage.labels.misc')}</h6>
							<StackVertical extraClass='sticky' gap={FlexGap.ExtraLarge} fill>
								<AccountTipsBlock title={t('overviewPage.labels.tips')} />
								<GetInTouch />
							</StackVertical>
						</div>
					</div>

					<GuidedTour />
				</StackVertical>
			</div>
		</div>
	);
}

export default Overview;
